import React from 'react';

export default function ManagedPortfolios() {
    
    return (
        // <div dangerouslySetInnerHTML={{ __html: "<iframe src='https://www.youtube.com/embed/cWDJoK8zw58' />"}} />
        // <iframe title="Report Section" width="100%" height="800" src="https://app.powerbi.com/view?r=eyJrIjoiZWU4YjAyNzktY2YzNi00NTk3LThjMmQtNDVlNWMzOWRjNGRiIiwidCI6IjUzM2ZmZDliLTA1MjEtNGFkOC04MTk3LTU5NjQyZjhiMjNjMyJ9" frameborder="0" allowFullScreen="true"></iframe>
        <iframe title="RoC Report PBI" width="100%" height="800" src="https://app.powerbi.com/view?r=eyJrIjoiNjIzNjYzY2YtZjJlMS00NGQzLWJhMGEtMjFlNzhlYjVkZTdiIiwidCI6IjMwMmI1MWU2LTBlOGQtNGFiMC1hY2ZmLThjNDdiYWRiODdhNSJ9" frameborder="0" allowFullScreen="true"></iframe>
    );
}
